/*
====================================================================================================
   All the functions are responsible for creating the message to be displayed in the Alert component
 ===================================================================================================
 */

import appSettings from '../appSettings';
import { WeatherOverrideAirline } from '../enums/enum';

export const validityMessageCreator = (...validityFlags: boolean[]): string => {
  const [
    isAirlineTypeValid = false,
    isPrinterTypeValid = false,
    isSelectStationValid = false,
    isSelectPrinterValid = false,
    isPacketTypeValid = false,
    isFlightOriginValid = false,
    isFlightNumberValid = false,
    isFlightDateValid = false,
  ] = validityFlags;

  let message = '';

  if (!isAirlineTypeValid) {
    message += 'Please select the Airline Type From the list in Step 3,';
  }

  if (!isPrinterTypeValid) {
    message += 'Please select the Printer Type From the list in Step 1,';
  }

  if (!isSelectStationValid) {
    message += 'Please select your Station from the list in Step 1,';
  }

  if (!isSelectPrinterValid) {
    message += 'Please select a Printer from the list in Step 1,';
  }

  if (!isPacketTypeValid) {
    message += 'Please select the Packet Type from the list in Step 2,';
  }

  if (!isFlightOriginValid) {
    message += 'Please enter an Origin Station from the list in Step 3,';
  }

  if (!isFlightNumberValid) {
    message += 'Please enter a Flight Number in Step 3,';
  }

  if (!isFlightDateValid) {
    message += 'Please select the Flight Date from the list in Step 3,';
  }

  return message;
};

export const briefingPacketOverrideMsg = (airline: string) => {
  let message = '';

  if (airline === WeatherOverrideAirline.AS) {
    message = `Alaska Airlines is using the backup briefing packet system. The link is located on the bottom left of the Pilot-Dispatcher Briefing page, or click link <a target="_blank" href="${appSettings.WEATHER_OVERRIDE_URL}">${appSettings.WEATHER_OVERRIDE_URL}</a> <ul><li>BE SURE TO SIGN PAPER RELEASE AND FIT FOR DUTY THEN LEAVE WITH STATION</li><li>GET FINAL NUMBERS FROM CLP MANUALLY</li></ul>`;
  } else if (airline === WeatherOverrideAirline.QX) {
    message = `Horizon Airlines is using the backup briefing packet system. The link is located on the bottom left of the Pilot-Dispatcher Briefing page or click link <a target="_blank" href="${appSettings.WEATHER_OVERRIDE_URL}">${appSettings.WEATHER_OVERRIDE_URL}</a> <br/>`;
  }

  return message;
};
